import React from 'react';

import './pages-finance-adjustment-note.css';

/* eslint-disable-next-line */
export interface PagesFinanceAdjustmentNoteProps {}

export function PagesFinanceAdjustmentNote(
  props: PagesFinanceAdjustmentNoteProps
) {
  return (
    <div>
      <h1>Welcome to pages-finance-adjustment-note!</h1>
    </div>
  );
}

export default PagesFinanceAdjustmentNote;
